import MyProjects from "./my-projects";
const MyProjectsPage = () => {
    return (
        <MyProjects />
    );
}

export default MyProjectsPage;